var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-component'),_c('main',{staticClass:"\n      main-content\n      position-relative\n      max-height-vh-100\n      h-100\n      border-radius-lg\n    "},[_c('router-view'),_c('footer-component')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }